import { render, staticRenderFns } from "./DecrementRoundIcon.vue?vue&type=template&id=138760c8&scoped=true"
import script from "./DecrementRoundIcon.vue?vue&type=script&lang=js"
export * from "./DecrementRoundIcon.vue?vue&type=script&lang=js"
import style0 from "./DecrementRoundIcon.vue?vue&type=style&index=0&id=138760c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138760c8",
  null
  
)

export default component.exports